export const getPassengers = state => state.toJS();

export const getPassengerById = (state, passengerId) =>
  state.find(passengers => passengers.id === passengerId);



// WEBPACK FOOTER //
// ./src/redux/selectors/PassengersSelectors.js